/* ARRAY - horizontal scrollers. Shared by the offers row and the beauty bag's
   rail; anything else that needs one only has to add `data-hs`.

   THE CSS DOES THE REAL WORK AND THIS IS AN ENHANCEMENT. Overflow, snap and
   touch swiping are pure CSS, so a phone scrolls these rows correctly even if
   this script never loads. What it adds is arrows, a counter, and drag with a
   mouse or a pen - the things a stylesheet cannot do.

   IT ONLY WAKES WHERE THERE IS SOMETHING TO SCROLL. Every one of these rows is
   a plain grid at desktop widths, so `canScroll` is false there, the arrows
   stay hidden and no listener does anything. That is why the same markup serves
   both layouts with no media query in JavaScript.

   THE THROTTLE IS A TIMER, NOT requestAnimationFrame. rAF never fires in a
   background tab - including Shopify's preview pane, where `document.hidden`
   is true - so an arrow would move the row but leave the counter and the
   disabled states frozen, and the section would look broken to anyone testing
   it there. A timer runs either way.

   SCROLL-SNAP FIGHTS A POINTER DRAG: snap keeps yanking the row back to the
   nearest cell mid-gesture, so the row carries `is-drag` for the length of the
   drag and the stylesheet drops snap under that class.

   TOUCH IS LEFT ALONE. The browser's own inertial scrolling beats anything
   reimplemented here, so `pointerdown` returns early for touch.

   A DRAG THAT ENDS ON A LINK MUST NOT NAVIGATE. Every cell is an anchor, so a
   swallow flag is set on release and read by a CAPTURE-phase click listener -
   capture, because the anchor's own handling would otherwise run first. It is
   cleared on the next press, so a drag never followed by a click cannot eat a
   later one.

   SMOOTH SCROLLING IS A NO-OP IN SHOPIFY'S PREVIEW PANE, so every arrow press
   is followed 380ms later by a check that jumps if nothing moved.
*/
(function () {
  'use strict';

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function gapOf(el) {
    var cs = getComputedStyle(el);
    var g = parseFloat(cs.columnGap);
    if (isNaN(g)) g = parseFloat(cs.gap);
    return isNaN(g) ? 0 : g;
  }

  /* One cell plus one gap. Measured off a real child every time, because the
     cell width is a percentage that changes with the viewport. */
  function stepOf(el) {
    var c = el.firstElementChild;
    if (!c) return el.clientWidth || 1;
    return Math.round(c.getBoundingClientRect().width + gapOf(el));
  }

  function canScroll(el) { return el.scrollWidth - el.clientWidth > 4; }

  function build(el) {
    if (el.__hs) return;
    el.__hs = true;

    var wrap = (el.closest && el.closest('[data-hs-wrap]')) || el.parentElement;
    var prev = wrap ? wrap.querySelector('[data-hs-prev]') : null;
    var next = wrap ? wrap.querySelector('[data-hs-next]') : null;
    var nav = wrap ? wrap.querySelector('[data-hs-nav]') : null;
    var count = wrap ? wrap.querySelector('[data-hs-count]') : null;
    var total = el.children.length;
    var tick = 0;

    function sync() {
      var max = el.scrollWidth - el.clientWidth;
      if (nav) nav.hidden = !canScroll(el);
      if (prev) prev.disabled = el.scrollLeft <= 2;
      if (next) next.disabled = el.scrollLeft >= max - 2;
      if (count) {
        var i = Math.round(el.scrollLeft / stepOf(el)) + 1;
        if (i > total) i = total;
        if (i < 1) i = 1;
        count.textContent = pad(i) + ' / ' + pad(total);
      }
    }

    function queue() {
      if (tick) return;
      tick = setTimeout(function () { tick = 0; sync(); }, 60);
    }

    function go(dir) {
      var from = el.scrollLeft;
      var target = from + dir * stepOf(el);
      try { el.scrollTo({ left: target, behavior: 'smooth' }); }
      catch (e) { el.scrollLeft = target; }
      setTimeout(function () {
        if (Math.abs(el.scrollLeft - from) < 2) el.scrollLeft = target;
        sync();
      }, 380);
    }

    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(-1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(1); });

    el.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    window.addEventListener('load', sync);

    /* ---- mouse and pen drag ---- */
    var down = false, moved = 0, sx = 0, sl = 0, id = null;

    el.addEventListener('pointerdown', function (e) {
      el.__swallow = false;
      if (e.pointerType === 'touch' || e.button !== 0 || !canScroll(el)) return;
      down = true; moved = 0; sx = e.clientX; sl = el.scrollLeft; id = e.pointerId;
      el.classList.add('is-drag');
    });

    el.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== id) return;
      var dx = e.clientX - sx;
      if (Math.abs(dx) > moved) moved = Math.abs(dx);
      if (moved > 3) {
        try { if (!el.hasPointerCapture(id)) el.setPointerCapture(id); } catch (err) {}
        el.scrollLeft = sl - dx;
        e.preventDefault();
      }
    });

    function up() {
      if (!down) return;
      down = false;
      try { if (id !== null && el.hasPointerCapture(id)) el.releasePointerCapture(id); } catch (err) {}
      id = null;
      el.classList.remove('is-drag');
      if (moved > 6) el.__swallow = true;
      sync();
    }
    el.addEventListener('pointerup', up);
    el.addEventListener('pointercancel', up);

    el.addEventListener('click', function (e) {
      if (el.__swallow) { el.__swallow = false; e.preventDefault(); e.stopPropagation(); }
    }, true);

    el.addEventListener('dragstart', function (e) { e.preventDefault(); });

    sync();
  }

  function boot() {
    var l = document.querySelectorAll('[data-hs]'), i;
    for (i = 0; i < l.length; i++) build(l[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
